// Home.js
import { Box } from "@mui/material";

import Header from '../components/Header';
import Footer from '../components/Footer';
import Content from '../components/Content';

const Home = () => {
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#1f2937",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <Box sx={{ flexGrow: 1 }}> 
        <Content /> 
      </Box>
      <Footer />
    </Box>
  );
};

export default Home;
